<template lang="pug">
  .component-vehicle-slot-disable
    ModalReveal(:ref="componentId")
      button.button.danger(slot="trigger") Disable
      .header(slot="header")
        h2 Disable vehicle slot

      .row
      .column
        .large-6.text-left
          label(v-if="!noreason") Reason
            input(type="text", v-model="body.reason")
          label Disable without reason
            input(type="checkbox", v-model="noreason", @change="toggleReason")
      ActionButton(slot="footer", color-class="success", :action="disable", :confirm="true") Disable

      button.button.alert.float-right(slot="footer", @click="$refs[componentId].close()") Cancel
</template>
<script type="text/babel">
import ModalReveal from '../../../foundation/ModalReveal'
import InputSwitch from '../../InputSwitch'
import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
import MaggieHelper from '../../../../../maggieHelper'
import ActionButton from "../../ActionButton";

export default {
  name: 'VehicleSlotDisableReveal',
  components: {ActionButton, InputSwitch, ModalReveal},
  data() {
    return {
      body: {reason: null},
      noreason: false
    }
  },
  created() {
  },
  methods: {
    disable: function () {
      return KeplerBackofficeSdk.vehicleSlots.select(this.item.slot_id).disable(this.body, (response) => {
        MaggieHelper.notification('disable-esit', 'vehicle slot disabled')
        this.$refs[this.componentId].close()
      })
    },
    toggleReason() {
      this.body.reason = this.noreason ? '<>' : null
    }
  },
  computed: {
    componentId() {
      return `vehicle-slot-disable-${this.item.id}`
    }
  },
  props: ['item'],
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-reveal-void
  .modal-footer
    .footer
      display: flex
      justify-content: space-around
</style>



// WEBPACK FOOTER //
// VehicleSlotDisableReveal.vue?76b99959